import { useState } from 'react';
import useLogin from '../providers/use_login';
import API from "../providers/api";

export default () => {
  const [executing, setExecuting] = useState(true);
  const {token} = useLogin()

  const config = {
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
  };


  const doAcceptPropuesta = async id => {
    setExecuting(true)
    const res = await API.put("propuestas/aprobar/" + id, {}, config);
    setExecuting(false)

    if (res?.status === 204) return true
    else return false
  }

  const doDeletePropuesta = async id => {
    setExecuting(true)
    const res = await API.put("propuestas/rechazar/" + id, {}, config);
    setExecuting(false)

    if (res?.status === 204) return true
    else return false
  }

  return {executing, doDeletePropuesta, doAcceptPropuesta};
}